import React from 'react';
import PropTypes from 'prop-types';
import {
  FDClickableText, FDStack, Stack,
} from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { metaOverrideSet } from './metaOverride';
import Layout from './layout';

const Content = ({ resource, canSubmit, handleSecondaryNext }) => {
  return (
    <Stack direction={'column'} alignItems={'center'}>
      <Stack direction={'column'} alignItems={'center'} maxWidth={684} spacing={2}>
        <MetaResourceRenderer
          resource={resource}
          layout={Layout}
          metaOverrideSet={metaOverrideSet}
        />
        {canSubmit && resource.withRelationship(fr.relationships.allowConciergeScheduleForNonAcats.name,
          (rel) => {
            return (
              <FDStack direction={'column'} alignItems={'center'}>
                <FDClickableText
                  appearance={'standalone'}
                  label={rel.meta('prompt')}
                  onClick={canSubmit ? handleSecondaryNext : null}
                  {...dataAttrs('schedule-chili-piper-meeting-secondary-button')}
                />
                <MetaControlField attr={'scheduleCallDisclaimer'} />
              </FDStack>);
          }, () => null)}
      </Stack>
    </Stack>
  );
};

Content.defaultProps = {
};

Content.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  canSubmit: PropTypes.bool.isRequired,
  handleSecondaryNext: PropTypes.func.isRequired,
};

export default Content;
